import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VerificationRequestLogoType } from 'models';

@Injectable({
	providedIn: 'root',
})
export class VerificationLogoService {
	constructor(private http: HttpClient) {}

	getUrl(verificationRequestLogoType: VerificationRequestLogoType): Observable<string> {
		return this.http.get<string>(`api/verification-logo/get/${verificationRequestLogoType}`);
	}

	getUrlAsAdmin(verificationRequestLogoType: VerificationRequestLogoType, hostUserId: string): Observable<string> {
		return this.http.get<string>(`api/verification-logo/getAsAdmin/${verificationRequestLogoType}?userId=${hostUserId}`);
	}

	uploadLogo(verificationRequestLogoType: VerificationRequestLogoType, files: File[]): Observable<void> {
		const formData = new FormData();

		// Note: The files input control has been configured to only allow a single file to be
		// selected. However, it still returns an array of files.So we have to extract the file
		// from the array before we forward it for processing.
		for (const file of files) {
			formData.append('file', file, file.name);
		}

		return this.http.post<any>(`api/verification-logo/upload/${verificationRequestLogoType}`, formData);
	}

	uploadLogoAsAdmin(verificationRequestLogoType: VerificationRequestLogoType, files: File[], hostUserId: string): Observable<void> {
		const formData = new FormData();

		// Note: The files input control has been configured to only allow a single file to be
		// selected. However, it still returns an array of files.So we have to extract the file
		// from the array before we forward it for processing.
		for (const file of files) {
			formData.append('file', file, file.name);
		}

		return this.http.post<void>(`api/verification-logo/uploadAsAdmin/${verificationRequestLogoType}?userId=${hostUserId}`, formData);
	}
}
